import { createContext } from 'react';
import { IAccountContext } from '../models/Account/IAccountContext.ts';

export const AccountContext = createContext<IAccountContext>({
    // logoutEverywhere: async () => { },
    changePassword: async (actualPassword: string, password: string, confirmPassword: string, logoutFromAllDevices: boolean) => {
        actualPassword;
        confirmPassword;
        password;
        logoutFromAllDevices;
    },
    getMe: function(rememberMe: boolean): Promise<void> {
        rememberMe;
        throw new Error('Function not implemented.');
    },
});